import aiDescriptionApi from './aiDescriptionApi'

export default aiDescriptionApi
